import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const ShieldCheckIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg
      width="27"
      height="33"
      viewBox="0 0 27 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1152 1.26998L13.6145 0.102304C13.4567 0.0348025 13.2869 0 13.1152 0C12.9436 0 12.7738 0.0348025 12.616 0.102304L13.1152 1.26998ZM13.1152 31.7312L12.4857 32.8329C12.6774 32.9424 12.8944 33 13.1152 33C13.3361 33 13.553 32.9424 13.7448 32.8329L13.1152 31.7312ZM12.6143 0.103996L1.79721 4.73918L2.79228 7.07454L13.6128 2.43766L12.6143 0.103996ZM0 7.46207V19.0712H2.53843V7.46207H0ZM5.75548 28.988L12.4857 32.8329L13.7448 30.6295L7.01454 26.7829L5.75548 28.988ZM13.7448 32.8329L20.475 28.988L19.2159 26.7829L12.4857 30.6295L13.7448 32.8329ZM26.2305 19.0695V7.46376H23.6921V19.0729L26.2305 19.0695ZM24.4367 4.74087L13.6145 0.103996L12.616 2.43597L23.4365 7.07454L24.4367 4.74087ZM26.2305 7.46376C26.2305 6.27916 25.5248 5.20794 24.4367 4.74087L23.4365 7.07454C23.5125 7.10731 23.5772 7.16165 23.6226 7.23083C23.6681 7.30002 23.6922 7.381 23.6921 7.46376H26.2305ZM20.475 28.988C22.2233 27.989 23.6764 26.5456 24.6871 24.804C25.6979 23.0625 26.2303 21.0848 26.2305 19.0712H23.6921C23.6917 20.637 23.2776 22.175 22.4915 23.5293C21.7055 24.8835 20.5754 26.006 19.2159 26.7829L20.475 28.988ZM0 19.0712C0.000180685 21.0848 0.532616 23.0625 1.54335 24.804C2.55409 26.5456 4.00721 27.989 5.75548 28.988L7.01454 26.7829C5.65479 26.0058 4.52463 24.8831 3.73856 23.5285C2.9525 22.1739 2.53847 20.6356 2.53843 19.0695L0 19.0712ZM1.79383 4.73918C1.26144 4.96759 0.807743 5.34714 0.488901 5.83081C0.170058 6.31449 7.57564e-05 6.88276 0 7.46207H2.53843C2.53843 7.29284 2.63997 7.13884 2.79566 7.07115L1.79383 4.73918Z"
        fill="currentColor"
      />
      <path
        d="M18.1928 13.116L11.4236 19.8851L8.03906 16.5005"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </StyledSvgIcon>
);
export default ShieldCheckIcon;

ShieldCheckIcon.propTypes = customIconsPropTypes;
